<template>
  <nav :aria-label="ariaLabel" class="mb-8">
    <div class="mb-4 flex flex-wrap items-baseline gap-x-2 gap-y-1">
      <p class="text-sm text-muted">
        Pasul {{ currentStep }} din {{ steps.length }}
      </p>
      <p class="text-base font-semibold text-highlighted">
        {{ currentLabel }}
      </p>
    </div>

    <ol class="flex items-start gap-0 sm:gap-1 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-none">
      <li
        v-for="(step, index) in steps"
        :key="step.id"
        class="flex items-start min-w-0"
        :class="steps.length > 5 ? 'flex-1 basis-0' : 'flex-1'"
      >
        <div
          class="flex flex-col items-center min-w-0 w-full"
          :title="step.label"
        >
          <div
            class="flex items-center justify-center w-9 h-9 rounded-full border-2 text-sm font-semibold transition-colors shrink-0"
            :class="stepCircleClass(index + 1)"
            :aria-current="index + 1 === currentStep ? 'step' : undefined"
          >
            <UIcon
              v-if="index + 1 < currentStep"
              name="i-heroicons-check"
              class="w-5 h-5"
            />
            <span v-else>{{ index + 1 }}</span>
          </div>
          <span
            class="mt-2 hidden sm:block text-[11px] md:text-xs text-center leading-snug px-0.5 w-full break-words hyphens-auto line-clamp-2"
            :class="index + 1 === currentStep
              ? 'text-highlighted font-semibold'
              : index + 1 < currentStep
                ? 'text-highlighted font-medium'
                : 'text-dimmed'"
          >
            {{ step.label }}
          </span>
        </div>
        <div
          v-if="index < steps.length - 1"
          class="h-0.5 w-3 sm:w-4 md:flex-1 md:min-w-3 mx-0.5 sm:mx-1 mt-[17px] rounded-full transition-colors shrink-0"
          :class="index + 1 < currentStep ? 'bg-primary-500' : 'bg-muted'"
          aria-hidden="true"
        />
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
export interface CheckoutStep {
  id: number | string
  label: string
}

const props = withDefaults(defineProps<{
  steps: CheckoutStep[]
  currentStep: number
  ariaLabel?: string
}>(), {
  ariaLabel: 'Pași finalizare comandă',
})

const currentLabel = computed(() => {
  const match = props.steps.find((step) => Number(step.id) === props.currentStep)
  return match?.label || ''
})

function stepCircleClass(stepNumber: number) {
  if (stepNumber < props.currentStep) {
    return 'border-primary-500 bg-primary-500 text-white'
  }
  if (stepNumber === props.currentStep) {
    return 'border-primary-500 bg-primary-50 dark:bg-primary-950/40 text-primary-700'
  }
  return 'border-default bg-default text-dimmed'
}
</script>
